import styled from '@emotion/styled'

export const DateTimeContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  column-gap: 20px;
`

export const SelectContainer = styled.div`
  padding: 20px 0;
`
